<template>
  <div class="my-4">
    <document-type-header
      :title="$t('iframe_page.doctypes.id')"
      :statusLabel="statusLabel"
      :statusIcon="statusIcon"
      :subTitle="subTitle">
      {{ $t('iframe_page.docinfo.id_1') }} <br>  {{ $t('iframe_page.docinfo.id_2') }} <br> {{ $t('iframe_page.docinfo.id_3') }}  <br> {{ $t('iframe_page.docinfo.id_4') }} <br> {{ $t('iframe_page.docinfo.id_5') }}
    </document-type-header>
    <div class="mt-2 form-group">
      <multiple-documents-upload multiple
      :canAdd="canAdd"
      :canDelete="canDelete"
      :canReplace="canReplace"
      v-model="uploadedFiles"
      :id="$options.name"
      :hasError="fileHasError"
      :errorMsg="$t('errors.invalid_id')"
      @resetError="fileHasError = false"
      @filesUploaded="resetStatut">
      </multiple-documents-upload>
    </div>
    <div v-if="showBtnValidate" class="my-4">
      <button type="button"
        class="validation-btn LMSG-background-color"
        :disabled="!canValidate || showLoader"
        @click="validateButton()">
        {{ $t('creation_forms.vldt') }}
      </button>
    </div>
  </div>
</template>

<script>
import DocumentTypeHeader from './DocumentTypeHeader.vue'
import multipleDocumentsUpload from './multipleDocumentsUpload.vue'

import globalStatus from './data/globalStatus.js'
import status from './data/status.js'

import '../LMSGstyle.css'

export default {
  name: 'DocumentPiV2',
  components: {
    'document-type-header': DocumentTypeHeader,
    'multiple-documents-upload': multipleDocumentsUpload
  },
  props: {
    subTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    canAdd () {
      return this.statusId === status.TO_COMPLETE
    },
    canDelete () {
      return this.statusId === status.TO_COMPLETE
    },
    canReplace () {
      return this.statusId === status.REFUSED
    },
    canShowValidate () {
      return (this.uploadedFiles.length || this.fileHasError) && !this.isWaiting && this.statusId !== status.ACCEPTED
    },
    canValidate () {
      return this.uploadedFiles.length
    },
    isWaiting () {
      return this.statusId === status.VERIFYING
    },
    uploadedFiles: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.pickStatus(this.getGlobalStatus(newVal))
    }
  },
  data: function () {
    return {
      statusId: '0',
      statusLabel: 'A compléter',
      statusIcon: '',
      showBtnValidate: true,
      fileHasError: false,
      showLoader: false
    }
  },
  created () {
  },
  mounted () {
    this.pickStatus(this.getGlobalStatus(this.value))
    this.showBtnValidate = this.statusId === status.TO_COMPLETE
    if (!this.showBtnValidate) {
      this.$emit('showInputs')
    }
  },
  methods: {
    getGlobalStatus (docList) {
      if (!docList.length || docList.filter(elem => !elem.Status || globalStatus.TO_COMPLETE.includes(elem.Status)).length) {
        return status.TO_COMPLETE
      } else if (docList.filter(elem => globalStatus.VERIFYING.includes(elem.Status)).length) {
        return status.VERIFYING
      } else if (docList.filter(elem => globalStatus.EXPIRED.includes(elem.Status)).length) {
        return status.EXPIRED
      } else if (docList.filter(elem => globalStatus.VALIDATED.includes(elem.Status)).length) {
        return status.VALIDATED
      } else if (docList.filter(elem => globalStatus.REFUSED.includes(elem.Status)).length) {
        return status.REFUSED
      }
    },
    pickStatus (statusToIdentify) {
      switch (statusToIdentify) {
        case status.TO_COMPLETE:
          this.statusId = status.TO_COMPLETE
          this.statusLabel = this.$t('iframe_page.status.to_complete')
          this.statusIcon = ''
          break
        case status.VERIFYING:
          this.statusId = status.VERIFYING
          this.statusLabel = this.$t('iframe_page.status.waiting')
          this.statusIcon = ''
          break
        case status.ACCEPTED:
          this.statusId = status.ACCEPTED
          this.statusLabel = ''
          this.statusIcon = 'success LMSGcolor'
          break
        case status.REFUSED:
          this.statusId = status.REFUSED
          this.statusLabel = this.$t('iframe_page.status.refused')
          this.statusIcon = 'icon fa-warning-o text-warning'
          break
      }
    },
    resetFileError () {
      this.fileHasError = false
    },
    resetStatut () {
      let result = Math.floor(Math.random() * 2).toString()
      this.pickStatus(result)
    },
    validateButton () {
      let that = this
      this.showBtnValidate = false
      this.pickStatus(status.VERIFYING)
      that.$emit('validateBtn')
      this.showLoader = true
      let docData = ''
      this.uploadedFiles.forEach((item, i) => {
        item.Status = 11
        item.Type = 'IDCARD'
        docData += i === 0 ? item.Data : ';' + item.Data.substring(item.Data.indexOf(',') + 1)
      })
      that.$engine.services.ocr(
        that.$engine.user.get().id,
        '',
        docData,
        'jpeg',
        'scan',
        'IDCARD'
      )
      // this.$engine.services.suppliers.uploadDocument({
      //   IdDocument: that.idDocument,
      //   DocumentType: 'IDCARD',
      //   DocumentName: that.uploadedFiles[0].Name,
      //   ocr: '1',
      //   DocumentData: docData
      // })
      // .then(resp => {
      //   that.pickStatus(status.VERIFYING)
      //   this.showBtnValidate = false
      //   this.showLoader = false
      // })
      // .catch(err => {
      //   console.log(err)
      //   that.fileHasError = true
      //   that.uploadedFiles = []
      // })
    }
  }
}
</script>



// WEBPACK FOOTER //
// DocumentPiV2.vue?05c43d80